
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      usuario: "",
      password: "",
      repitePassword: "",
      nombre: "",
      primerApellido: "",
      segundoApellido: ""
    };
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.registrar();
        } else {
          this.$toast.open({
            message: "Formulario no es valido! Por favor revisa los campos.",
            type: "is-danger",
            position: "is-bottom"
          });
        }
      });
    },
    registrar() {
      const loading = this.$loading.open({
        container: null
      });

      const datos = {
        contraseña: this.password,
        email: this.usuario,
        nombre: this.nombre.toUpperCase()[0] + this.nombre.slice(1),
        primerApellido:
          this.primerApellido.toUpperCase()[0] + this.primerApellido.slice(1),
        segundoApellido:
          this.segundoApellido.toUpperCase()[0] + this.segundoApellido.slice(1)
      };

      this.$http
        .post("Cuentas/Crear", datos)
        .then(() => {
          loading.close();

          this.$toast.open({
            message: "Registrado correctamente!",
            type: "is-success",
            position: "is-bottom"
          });
          this.$router.push("/login");
        })
        .catch(() => {
          loading.close();

          this.$toast.open({
            message: "Error al registrar",
            type: "is-danger",
            position: "is-bottom"
          });
        });
    }
  }
});
